<script>
    import { onMount } from "svelte";
    import { logoutUser } from '/public/services/users/users';
    import ThexaHero from '/shared/c/logo/ThexaHero.svelte';

    let working = true;

    onMount(() => {
        logoutUser().then(res => {
            if (res.success) {
                working = false;

                //window.location = '/';
            }
        });
    });
</script>
<div class='vh-100 mt-5'>
    <div class='mt-5'>

        <ThexaHero/>

    </div>

    <div class="row justify-content-center">
        <div class="col-sm-8 col-md-10">                            
                <h4 class='text-center'>
                    Log out
                </h4>                

                {#if working === true}

                    <div class='mb-5 text-center'>
                        <h4>
                            <span class='ajax-ball-loader'></span>
                        </h4>
                    </div>

                {:else}

                    <div class="mb-3 text-center">
                        <p>
                            You are now logged out.<br/>
                            Click <a href='/'>here</a> to return to the application.
                        </p>
                    </div>

                {/if}
                
           
        </div>
    </div>
</div>